import {createAddSlice} from "../genericCrudSlice";
import {addMovementApi} from "../../api/entities/movements";


const createMovementsSlice = createAddSlice('movements', addMovementApi);
export const {init: initCreateMovement} = createMovementsSlice.actions;
export const {addEntity: createMovement} = createMovementsSlice;
export default createMovementsSlice.reducer;